import React from "react";
import { BrowserRouter, StaticRouter, Route, Switch } from "react-router-dom";
import Header from "components/header/header";
import Footer from "components/footer/footer";
import Home from "components/home/Home";
import DynamicPage from "components/content/DynamicPage";
import * as Common from "components/common";
import helper from "components/utils/helper";
import { CMSContext, ConfigContext } from "./context/AppContext";
import { CmsLogin, CmsLogout, CmsPreview } from "components/cms";
import { Helmet } from "react-helmet";
import LiveChat from "react-livechat";
const MoRouter = () => {
  let CmsContext = false;
  const [cms, setCms] = React.useState(CmsContext);
  const [hasJSON, setHasJSON] = React.useState(false);
  let moConfig = React.useContext(ConfigContext);
  const [config, setConfig] = React.useState(moConfig);
  const configValue = { config, setConfig };
  const [randomKey] = React.useState(Math.random());
  let routes = [];

  React.useEffect(() => {
    setAppLanguage();
    // Flag JSON has not yet loaded
    //window.hasJSON = hasJSON;
    // Fetch cms json file
    fetchToCmsJson();

    // Event listeners
    window.addEventListener("changeCms", (e) => {
      if (e.detail && e.detail.cms) {
        setCms(e.detail.cms);
      }
    });
    // for Cms Draft Preview
    // window.addEventListener('message', (event) => {
    //   if (event.data && typeof(event.data) === 'string') {
    //       let eventData = JSON.parse(event.data);
    //       renderPreview(eventData);
    //   }
    // });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config]);

  // LiveChat
  React.useEffect(() => {
    // Event listener to disable/enable LiveChat in uat/production
    //Default
    if (helper.getEnvironment() === "uat") {
      let hideChatInterval = setInterval(() => {
        if (document.getElementById("chat-widget-container")) {
          hideLiveChat();
          clearInterval(hideChatInterval);
        }
      }, 500);
    }
    window.addEventListener("disableLiveChat", (e) => {
      if (e.detail && e.detail.env) {
        switch (e.detail.env) {
          default:
          case "uat":
            if (helper.getEnvironment() === "uat") {
              hideLiveChat(e.detail.disable);
            }
            break;
          case "production":
            if (helper.getEnvironment() === "produs") {
              hideLiveChat(e.detail.disable);
            }
            break;
          case "local":
            if (helper.getEnvironment() === "local") {
              hideLiveChat(e.detail.disable);
            }
            break;
        }
      }
    });
  }, []);

  function hideLiveChat(hide) {
    let liveChatContainer = document.getElementById("chat-widget-container");
    if (liveChatContainer) {
      liveChatContainer.style.display =
        hide === undefined || hide ? "none" : "block";
      if (liveChatContainer.style.display === "block") {
        liveChatContainer.style.width = "281px";
        liveChatContainer.style.height = "63px";
      }
    }
  }

    function fetchToCmsJson() {
        let url = helper.getAssetUrl(
            "cms",
            config.getCountry(),
            config.getLanguage()
        );

        let headers = {};

        // Need to add extra headers for pre-renderer to work
        // Check to see if we are on a cloudfront URL and add 
        // extra headers
        const hostname = window.location.hostname;
        if (hostname.includes("cloudfront.net") || hostname.includes("localhost")) {
            headers = { "x-mov-locale": config.getCountry(),  "Accept": "application/json", "Content-Type": "application/json" }
        }

        fetch(url, { "headers" : headers })
            .then((res) => {
                return res.json(); 
            })
            .then(
                (result) => {
                    combineCms(result);
                },
                (error) => {
                    // Get local cms json
                    //combineCms(cms);
                    console.log("Request error " + error);
                }
            );
    }

  function combineCms(cmsJson) {
    if (cmsJson && cmsJson.pages) {
      // let pages = { home: { url: "/", title: "Home" }};
      // pages = Object.assign(pages, cmsJson.pages);
      // cmsJson.pages = pages;
      setCms(cmsJson);
      // Flag JSON has loaded
      setHasJSON(true);
    }
  }

  function setAppLanguage() {
    let { pathname, hostname } = window.location;
    let countryCode = "au";
    // Country code
    if (
      hostname.charAt(2) === "." &&
      config.getCountry() !== hostname.substr(0, 2)
    ) {
      countryCode = hostname.substr(0, 2);
      if (config.getValue(["locale", countryCode])) {
        config.setCountry(countryCode);
      }
    } else {
        const cloudFront = {
            "d3nocjlgc7f5mm.cloudfront.net" : "ie",
            "d1ybcrxfz61yix.cloudfront.net" : "ca",
            "dseebj0wlmhxk.cloudfront.net" : "uk",
            "d1oez4kbvsai9h.cloudfront.net" : "us",
            "d49t9m54hx2iw.cloudfront.net": "au",
            "d1noq7r95tgipk.cloudfront.net" : "nz",
            "di6zu7qhqdhsr.cloudfront.net": "au", 
            "d2dvmzy18p3frk.cloudfront.net": "ca",
            "d23ezety1qok32.cloudfront.net": "ie",
            "d1ddvyclchmo4y.cloudfront.net" :"nz",
            "dfi88kws6r01o.cloudfront.net": "uk",
            "d8loua3wooenr.cloudfront.net" : "us" 
        };

        if (typeof cloudFront[hostname] === 'undefined') {
            const locale = new URLSearchParams(window.location.search).get('locale');
            if (!locale) {
                config.setCountry(countryCode);
            } else {
                const parts = locale.split("/"),
                  supportedLanguages = ["en", "fr"];
                if (
                  parts.length === 2 &&
                  supportedLanguages.indexOf(parts[1]) > -1
                ) {
                  config.setLanguage(parts[1]);
                }
                config.setCountry(parts[0]);
            }
        } else {
            config.setCountry(cloudFront[hostname]);
        }
    }

    // Language code
    if (
      (pathname.length <= 3 || pathname.charAt(3) === "/") &&
      pathname.substr(1, 2).length === 2 &&
      config.getLanguage() !== pathname.substr(1, 2)
    ) {
      let newLanguageCode = pathname.substr(1, 2);
      if (config.getValue(["locale", config.getCountry(), "language"])) {
        for (
          let i = 0;
          i <
          config.getValue(["locale", config.getCountry(), "language"]).length;
          i++
        ) {
          if (
            config.getValue(["locale", config.getCountry(), "language", i])
              .code === newLanguageCode
          ) {
            config.setLanguage(newLanguageCode);
            break;
          }
        }
      }
    } else {
       //MWD-6235: Direct French-speaking visitor to /fr in CA
      if (
        countryCode === "ca" &&
        navigator &&
        navigator.language &&
        navigator.language.substring(0, 2) === "fr" &&
        !helper.getCookie('language-bar-is-disabled')
      ) {
        config.setLanguage("fr");
        window.location = "/fr/";
      }
    }
  }

  //function renderPreview(json) {
    //let newCms = cms;
    //for (let id in json) {
      //if (typeof newCms.components[id] === "undefined") {
        //newCms["pages"]["stories"]["components"].push({
          //id: id,
          //title: json[id]["title"],
          //url: json[id]["url"],
          //components: [id],
        //});
      //}
      //newCms.components[id] = json[id];
    //}
    //setCms(newCms);
    // Need to re-render current page to see new changes.
    // Can NOT reload the page as it would retrieve the cms again
    // Generate new random key in Article route for re-rendering article page in react-router
    //setRandomKey(Math.random());
  //}

  return <React.Fragment>{renderRouter()}</React.Fragment>;

  function renderRouter(params) {
    let location = params && params.location ? params.location : "",
      RouterType = params && params.ssr ? StaticRouter : BrowserRouter;

    const returnPage = () => {
      return (
        <CMSContext.Provider value={cms}>
          {/* Metadata */}
          {cms && renderMetaTags()}
          <div id="clipboard-container"></div>
          {/* React Router */}
          <RouterType location={location}>
            <Header cms={cms} />
            <CmsPreview />
            <div id="content-container">
              <Switch>{getRoutes()}</Switch>
            </div>
          </RouterType>
          {/* Live chat */}
          {config.getValue(["livechat.enabled"]).indexOf(config.getCountry()) >
            -1 && <LiveChat license={config.getValue("livechat.licenseId")} />}
          <Footer cms={cms} />
          <div id="json-loaded"></div>
        </CMSContext.Provider>
      );
    };

    const returnPreRenderedHTML = () => {
      let innerHTML = document.getElementById("root").innerHTML;
      return (
        <div id="noJSON">
          {innerHTML > 0
            ? (React.dangerouslySetHTML =
                document.getElementById("root").innerHTML)
            : ""}
        </div>
      );
    };

    return (
      <ConfigContext.Provider value={configValue}>
        {!hasJSON ? returnPreRenderedHTML() : returnPage()}
      </ConfigContext.Provider>
    );
  }

  function renderMetaTags() {
    return (
      <React.Fragment>
        {/* React Helmet to manage meta tags in document head */}
        {cms.siteSettings && cms.siteSettings.metadata && (
          <Helmet>
            <meta
              name="application-name"
              content={cms.siteSettings.metadata.title}
            />
            <meta
              name="description"
              content={cms.siteSettings.metadata.description}
            />
            <link
              rel="icon"
              href={helper.getImage(
                cms.siteSettings.metadata["fav-icon"],
                "small"
              )}
            />
            <link
              rel="apple-touch-icon"
              href={helper.getImage(
                cms.siteSettings.metadata["fav-icon"],
                "small"
              )}
            />
            {/* Open Graph meta tags */}
            <meta property="og:url" content={window.location.href} />
            <meta
              property="og:locale"
              content={`${config.getLanguage()}_${config.getCountry()}`}
            />
            <meta
              property="og:title"
              content={cms.siteSettings.metadata.title}
            />
            <meta property="og:type" content="website" />
            <meta
              property="og:image"
              content="https://cdn.movember.com/uploads/images/Logos/Movember_Iconic%20Mo_Black.jpg"
            />
            <meta
              property="og:description"
              content={cms.siteSettings.metadata.description}
            />
          </Helmet>
        )}
      </React.Fragment>
    );
  }

  function getRoutes() {
    // Render Routes from static pages and dynamic pages from cms context
    for (const pageName in cms.pages) {
      let route = cms.pages[pageName];
      route.components && route.components.length > 0
        ? addDynamicPages(route, pageName)
        : addStaticPages(route, pageName);
    }
    // Add No-Match route (404)
    routes.push(<Route path="*" component={Common.NoRoute} key="no-route" />);
    return routes;
  }

    function addStaticPages(route, page) {
        let pageComponent = Home;
        switch (page) {
            default:
            case "home":
                pageComponent = Home;
                break;
            case "cms-login":
                pageComponent = CmsLogin;
                break;
            case "cms-logout":
                pageComponent = CmsLogout;
                break;
        }
        routes.push(
            <Route
                exact
                path={route.url}
                component={pageComponent}
                key={page}
            >
            </Route>
        );
    }

    function getIndexRoutePath(url) {
        const currentLanguage = config.getLanguage();
        let indexRoutePath = "/";
        // Need to check if the page is a language page
        if (url.indexOf(`/${currentLanguage}/`) === 0 ) {
            indexRoutePath = `/${currentLanguage}/`;
        }
        return indexRoutePath;
    }

    function addDynamicPages(route, page) {
        const indexRoutePath = getIndexRoutePath(route.url);
        
        if (route.url && route.url !== indexRoutePath && route.components && route.url ) {
         
          routes.push(
                <Route
                exact
                path={route.url}
                key={page}
                >
                <DynamicPage cms={cms} page={page} componentList={route.components} />
                </Route>
            );
        }
        switch (page) {
            
            default:
            case "stories":
            case "content":
                addRoutes(route.components, page === "stories" ? "story" : page);
                break;
            
        }
    }

    function addRoutes(pages, pageName) {
        const currentLanguage = config.getLanguage();
        const regex = new RegExp(`(/${currentLanguage}/index|/index)`, "g");
        const regexTest = new RegExp(`(/${currentLanguage}/test|/test)`, "g");
       
      
          pages.map((page) => {
            const pageHomeFound = page.url.match(regex);
            
            // Temporary homepage
            if(pageHomeFound) {
                const indexRoutePath = getIndexRoutePath(page.url);
                routes.push(
                    // For Story, set randomKey to re-render this component to see changes on Preview
                    <Route
                    exact
                    path={indexRoutePath}
                    key={'homepage'}
                    >
                    <DynamicPage
                    cms={cms}
                    content={page}
                    page={pageName}
                    componentList={page.components}
                    />
                    </Route>
                );
            }

           
            
            routes.push(
                <Route
                exact
                path={page.url}
                key={pageName === "story" ? randomKey : page.id}
                >
                <DynamicPage
                cms={cms}
                page={pageName}
                content={page}
                componentList={page.components}
                />
                </Route>
            );

            return true;
        });
        

       
    }
};

export default MoRouter;
